/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */

import { PolymerElement } from "@polymer/polymer/polymer-element.js";
import { html } from "@polymer/polymer/lib/utils/html-tag.js";
import template from "./ns-searchbar-legacy.html";
import {
  ConfigService,
  RunConfigService,
  SearchSessionStorageService,
  SearchBarAdapter,
  util,
  SitesLocalStorageService,
  SitesSessionStorageService,
  events,
  StringService
} from "@nuskin/ns-util";
import {
  SolrQueryService,
  ProductSearchService,
  CartService,
  ProductStatusService,
  CurrencyService,
  ProductService,
  AssessmentService,
  Agelocme,
  Product
} from "@nuskin/ns-shop";
import $ from "@nuskin/nuskinjquery";
import { NsSlottedDropdown } from "@nuskin/ns-form-elements";
import { MarketHeaderService } from "@nuskin/ns-product";

const SEARCH_TERM_KEY = "searchResultsData";
const POPULAR_PRODUCTS_SEARCH_DROPDOWN_KEY = "popularProductsSearchDropdown";
const KEY_BREADCRUMB_BACK = "breadcrumbBack";

const SEARCH_BUTTON_TOOLTIPS_KEY = "searchButtonTooltip";
const ICONS_CONTAINER_TOOLTIPS_KEY = "iconsContainerTooltip";

/**
 * <h1>Search Bar</h1>
 * <demo-snippet class="demoSnippet">
 *   <template>
 *     <ns-searchbar-legacy></ns-searchbar-legacy>
 *   </template>
 * </demo-snippet>
 * <h3>Custom Search Bar</h1>
 * <demo-snippet class="demoSnippet">
 *   <template>
 *     <ns-searchbar-legacy mode="custom" disable-search-on-enter search-ageloc no-search-button show-pricing-in-predictive order-type-in-predictive search-options='{"predictiveLimit":10, "searchFields":[1,2,7], "resultTypes":2, "orderTypes":["adr"]}'></ns-searchbar-legacy>
 *   </template>
 * </demo-snippet>
 * Example javascript that can be used to create the search options used in the preceding snippet:<br/>
 *
 * <demo-snippet>
 * var fields = ProductSearchService.getSearchFieldsEnum();<br/>
 * var sort = ProductSearchService.getSortOrderEnum();<br/>
 * var resTypes = ProductSearchService.getResultTypesEnum();<br/>
 * var orderTypes = ProductSearchService.getOrderTypesEnum();<br/>
 * var options = {<br/>
 *   &nbsp;&nbsp;&nbsp;&nbsp; searchFields: [fields.SKU, fields.TITLE, fields.SEARCH_TERMS],<br/>
 *   &nbsp;&nbsp;&nbsp;&nbsp; predictiveLimit: 10,<br/>
 *   &nbsp;&nbsp;&nbsp;&nbsp; resultTypes: resTypes.PRODUCTS_AND_VARIANT_PRODUCTS,<br/>
 *   &nbsp;&nbsp;&nbsp;&nbsp; orderTypes: [orderTypes.ADR]<br/>
 * };
 * </demo-snippet>
 * NsSearchbarLegacy componenimg/dev-portal/src/img/glow-girl.pngt consists of:
 *  <ul>
 *    <li>
 *       NsDropdown:
 *       <ul>
 *          <li>Used to narrow down results by category.</li>
 *       </ul>
 *    <li>
 *       NsInput:
 *       <ul>
 *          <li>
 *             The search text input is an active input and holds the value for any search performed. It shows the following options:
 *             <ul>
 *                <li>
 *                   <ul>
 *                      <li>This section allows for us to pipe in popular searches as the input becomes active, however this will go away once typing begins.</li>
 *                      <li>Kicks off a search for selected item when clicked.</li>
 *                   </ul>
 *                </li>
 *                <li>
 *                   Recent Searches:
 *                   <ul>
 *                      <li>Kicks off a search for selected item when clicked.</li>
 *                   </ul>
 *                </li>
 *                <li>
 *                   Predictive Searches:
 *                   <ul>
 *                      <li>A debounced function that will run every 400ms after typing has begun. These are what will populate the background input on hover.</li>
 *                      <li>Kicks off a search for selected item when clicked.</li>
 *                   </ul>
 *                </li>
 *             </ul>
 *       </ul>
 * </ul>
 *
 */
export class NsSearchbarLegacy extends PolymerElement {
  static get is() {
    return "ns-searchbar-legacy";
  }

  static get template() {
    let htmlElement = document.createElement("TEMPLATE");
    htmlElement.innerHTML = template;
    return htmlElement;
  }

  constructor() {
    super();
    this.isSearchLoading = false;
    this.previousQuery = "";
  }

  ready() {
    super.ready();
    if (!this.tabIndex || this.tabIndex === -1) this.tabIndex = "100";

    this.addEventListener("blur", (e) => {
      this._handleBlur(e);
    });

    if (this.usingTooltips) {
      //PP-1019 temporary fix for two ns-searchbars in the header body.jsp.  Remove lines referring to mod when the new header is ready.
      let iconsKey = SitesLocalStorageService.getItem(
        ICONS_CONTAINER_TOOLTIPS_KEY
      );
      let barTooltip = iconsKey.showIconsContainerTooltip;
      let barToolMod = iconsKey.iconsContainerMod || false;
      let buttonTooltip = SitesLocalStorageService.getItem(
        SEARCH_BUTTON_TOOLTIPS_KEY
      ).showSearchButtonTooltip;
      if (typeof barTooltip !== "number") barTooltip = 0;
      if (typeof buttonTooltip !== "number") buttonTooltip = 0;
      if (barTooltip % 2 == 0) {
        if (!barToolMod) {
          barTooltip /= 2;
          barToolMod = true;
        }
      }
      if (barTooltip >= this.tooltipMax) {
        this.showIconsContainerTooltip = false;
      } else {
        this.showIconsContainerTooltip = true;
        SitesLocalStorageService.writeItem(ICONS_CONTAINER_TOOLTIPS_KEY, {
          showIconsContainerTooltip: ++barTooltip,
          iconsContainerMod: barToolMod
        });
      }
      if (buttonTooltip >= this.tooltipMax) {
        this.initialShowSearchButtonTooltip = false;
      } else {
        this.initialShowSearchButtonTooltip = true;
      }

      setTimeout(() => {
        this.showIconsContainerTooltip = false;
      }, 6000);
    }

    this._definePlaceholderText();
    window.onresize = () => {
      this._definePlaceholderText();
    };

    let runConfig = RunConfigService.getRunConfig();
    (this.nsConfig = ConfigService.getMarketConfig()),
    (this.market = runConfig.country ? runConfig.country : this.market);
    this.language = runConfig.language ? runConfig.language : this.language;
    //Delay loading user assessments for 1 second to give page time to load user data.
    setTimeout(() => {
      if (this.searchAgeLocEnabled()) {
        this.loadUserAssessments();
      }
    }, 1000);

    this._displaySearchLists();
    this.$.searchInput.addEventListener("input", (e) => {
      this._displaySearchLists();
    });

    this.debouncedPredictiveSearch = _.debounce(this.typeAhead, 400);

    events.subscribe("closeResultsPage", () => {
      this.value = "";
      this.previousQuery = "";
    });

    if (!!this.popularSearchData && this.popularSearchData.length > 0) {
      this.getPopularProducts();
    }

    this.PSVString = "SV";
    StringService.getStrings([{ key: "psvDist", dflt: "SV" }]).then(
      (strings) => {
        this.PSVString = strings.psvDist;
      }
    );
  }

  static get properties() {
    return {
      currentSelection: String,
      /**
       * Translated values for static text within component.
       */
      translations: {
        type: Object,
        value: {
          popularSearches: "Popular Searches",
          clearSearch: "Clear Recent",
          desktopPlaceholder: "Search products",
          mobilePlaceholder: "Search",
          search: "search",
          cancel: "cancel",
          searchButtonTooltip:
            "Click SEARCH or hit enter to complete your search",
          iconsContainerTooltip:
            "Use this bar to search and add products to your bag",
          seeMoreResults: "See More Results"
        },
        observer: "_definePlaceholderText"
      },
      /**
       *  Logic below tells us what placeholder value to use depending on window size.
       */
      placeholderText: {
        type: String,
        value: "",
        notify: true
      },
      /**
       * List of catagories to filter search by.
       */
      dropdownOptions: {
        type: Array,
        value: [
          ["Search All"],
          ["Products"]
          // ["Brands"],
          // ["Media Center"]
        ],
        observer: "_hideDropdown"
      },
      /**
       *  Used to show or hide the filter dropdown. Automatically evaluates to false (shown) when
       *  there are two or more categories we can search by.
       *  <strong>NOT TO BE ASSIGNED THROUGH ATTRIBUTE</strong>
       */
      dropdownHidden: {
        type: Boolean,
        value: false
      },
      /**
       *  Used to store the actually value typed in by a user.  This is necessary because we change the
       *  inputs value when hovering over, or down arrows onto, items in search dropdown so that if the user comes
       *  back to the input box it goes back to just what they've typed.
       *  <strong>NOT TO BE ASSIGNED THROUGH ATTRIBUTE</strong>
       */
      typedVal: {
        type: String,
        value: "",
        observer: "_searchButtonActivator"
      },
      focused: {
        type: Boolean,
        reflectToAttribute: true,
        notify: true
      },
      /**
       * Used to pass the language to our Solr Query.
       */
      language: {
        type: String,
        value: "en"
      },
      /**
       * Used to pass the market to our Solr Query.
       */
      market: {
        type: String,
        value: "US"
      },
      /**
       * This will be set when we start using the filter options.
       */
      category: {
        type: String,
        value: "Products"
      },
      /**
       * This will be set when a searchRequested event has been launched.
       * It prevents us from sending a separate searchRequested event for the full product search if another searchType has already been fired.
       */
      searchRequestedHasFired: {
        type: Boolean,
        value: false
      },
      /**
       * Set when the user has recent searches located in their browsers local storage.
       * <strong>NOT TO BE ASSIGNED THROUGH ATTRIBUTE</strong>
       */
      recentSearchData: {
        type: Array,
        value: []
      },
      /**
       * Set for now through content contribution, eventually to be set by analytical data.
       */
      popularSearchData: {
        type: Array,
        value: []
      },
      /**
       * Set after user starts typing and we start predicting their search.
       * <strong>NOT TO BE ASSIGNED THROUGH ATTRIBUTE</strong>
       */
      predictiveSearchData: {
        type: Array,
        value: [],
        observer: "handleShowMore"
      },
      /**
       * Used to change the search options from the defaults. All parameters in the options are optional.  It should be an object that looks like this:
       * {
       *      "market": "US",
       *      "language": "en",
       *      "orderTypes": ["order", "zpo"],
       *      "predictiveLimit": 6,
       *      "resultTypes": 3,
       *      "searchFields": [1, 2, 7],
       *      "sortField": 2,
       *      "sortOrder": "desc"
       *  }
       */
      searchOptions: {
        type: Object,
        observer: "_handleInputSearchOptions"
      },
      /**
       * Use orderTypes from search-options in the predictive results *** WILL MAKE TWO CALLS TO SOLR AND WILL DECREASE PERFORMANCE -- only use if you are sure you need it ***
       */
      orderTypeInPredictive: {
        type: Boolean,
        value: false
      },
      /**
       * After search is completed.  This gets passed to search results through data binding, binding the siblings.
       * <strong>NOT TO BE ASSIGNED THROUGH ATTRIBUTE</strong>
       */
      searchResults: {
        type: Array,
        value: [],
        notify: true,
        reflectToAttribute: true
      },
      /**
       * After query has been successfully completed.  This gets passed to search results through data binding.
       * <strong>NOT TO BE ASSIGNED THROUGH ATTRIBUTE</strong>
       */
      query: {
        type: String,
        notify: true
      },
      /**
       * Used to set the value inside the input field
       */
      value: {
        type: String,
        reflectToAttribute: true,
        observer: "_updateSearchValue"
      },
      /**
       * Used for different functionality for types of modes such as cart.
       */
      mode: {
        type: String
      },
      popularSearchArray: {
        type: Array,
        value: []
      },
      /**
       * Shows a search button in mobile view rather than a search input
       */
      showMobileButton: Boolean,
      /**
       * Used to hide search button
       */
      noSearchButton: {
        type: Boolean,
        value: false
      },
      /**
       * Items to display as a search result in slotted view
       */
      slottedSearchedItems: {
        type: Array,
        value: []
      },
      /**
       * This will disable the predictive type ahead search
       */
      disablePredictiveSearch: {
        type: Boolean,
        value: false
      },
      /**
       * This will hide the add to cart button in type-ahead (predictive) results
       */
      hideAddToBag: {
        type: Boolean,
        value: false
      },
      submitButtonActive: {
        type: Boolean,
        value: false,
        reflectToAttribute: true,
        notify: true
      },
      /**
       * This will show pricing in type-ahead (predictive) results
       * PLEASE USE THIS CAREFULLY -- this will force the predictive search to make a call to the product status service and will decrease performance and increase load
       * This was designed to be used in a cart context (ADR or cart page).
       */
      showPricingInPredictive: {
        type: Boolean,
        value: false
      },

      showMoreButton: {
        type: Boolean,
        value: false
      },

      hideSeeMoreResults: {
        type: Boolean,
        value: false
      },

      showMoreClicked: {
        type: Boolean,
        value: false
      },

      showIconsContainerTooltip: {
        type: Boolean,
        value: false,
        reflectToAttribute: true
      },

      showSearchButtonTooltip: {
        type: Boolean,
        value: false,
        reflectToAttribute: true
      },

      /**
       * We will show the tooltips only if using the searchbar in the header.
       * These tooltips are for search functionality demonstrations to end users
       */
      usingTooltips: {
        type: Boolean,
        value: false,
        reflectToAttribute: true
      },
      context: {
        type: String,
        value: ""
      },
      tooltipMax: {
        type: Number,
        value: 3
      },
      searchAgeloc: {
        type: Boolean,
        value: false
      },
      disableSearchOnEnter: {
        type: Boolean,
        value: false
      },
      addToCartOnClick: {
        type: Boolean,
        value: false
      }
    };
  }

  handleShowMore() {
    let limit =
      this.searchOptions && this.searchOptions.predictiveLimit
        ? this.searchOptions.predictiveLimit
        : 7;
    this.showMoreButton =
      this.predictiveSearchData.length > 0 &&
      this.psTotalItemsFound > limit &&
      !this.showMoreClicked;
  }
  /**
   * Used to query Solr the list of popular product skus and format them correctly to display on popular search section
   */
  getPopularProducts() {
    SolrQueryService.getProductsBySKUArray(
      this.popularSearchData,
      this.language,
      this.market
    ).then((response) => {
      let popularProducts = SearchBarAdapter.adaptPopularProductsResults(
        response,
        this.market,
        this.language
      );
      this.set("popularSearchArray", popularProducts);
    });
  }

  /* Internal function used to set placeholder text depending on what size the screen is. */

  _definePlaceholderText() {
    if (window.outerWidth > 1023) {
      this.set("placeholderText", this.translations.desktopPlaceholder || "");
    } else if (this.translations.mobilePlaceholder) {
      this.set("placeholderText", this.translations.mobilePlaceholder || "");
    } else {
      this.set("placeholderText", this.translations.desktopPlaceholder || "");
    }
  }

  /* Internal function used to process and pass the correct data to search results */

  _setResults(category, skus) {
    // Create holder array and empty item obj to pass results as it's expecting.
    let searchResults = [];
    let item = {};
    item.sectionTitle = category;
    item.resultsList = skus;
    searchResults.push(item);
    // Set data so the changes are observable
    this.set("searchResults", searchResults);
    this.set("predictiveSearchData", []);
    this.psTotalItemsFound = 0;
  }

  //This function processes search options passed in as an attribute
  _handleInputSearchOptions() {
    if (typeof this.searchOptions === "string") {
      this.searchOptions = JSON.parse(this.searchOptions);
    }
  }

  /************************************/
  /***                              ***/
  /***   HIDE SHOWS AND TOGGLES     ***/
  /***                              ***/
  /************************************/

  /*
   * Determine which of the 3 search dropdowns we should be displaying
   */
  _displaySearchLists() {
    if (this.$.searchInput.value.length > 0 && !this.disablePredictiveSearch) {
      this.$.predictiveSearches.show();
      if (
        (typeof this.value === "object" || typeof this.value === "undefined") &&
        !this.value &&
        this.typedVal.length > 0
      ) {
        this.$.recentSearches.hide();
        this.$.popularSearches.hide();
        this.$.popularSearches.style.setProperty("max-height", "0"); //Firefox bug fix
        this.value = this.typedVal;
        this.blur();
        this.submitSearch();
      }
    } else if (this.recentSearchData.length > 0 && this.mode != "cart") {
      this.$.recentSearches.show();
      this.$.predictiveSearches.hide();
      this.$.popularSearches.show();
      this.$.popularSearches.style.removeProperty("max-height"); //fixes a bug in firefox.
      if (util.MobileUtils.isMobile()) {
        this.$.popularSearches.hide();
        this.$.popularSearches.style.setProperty("max-height", "0"); //Firefox bug fix
      }
    } else if (this.mode != "cart") {
      this.$.recentSearches.hide();
      this.$.predictiveSearches.hide();
      this.$.popularSearches.show();
      this.$.popularSearches.style.removeProperty("max-height"); //fixes a bug in firefox.
    } else {
      this.$.recentSearches.hide();
    }
  }

  _hideDropdown() {
    if (this.dropdownOptions.length <= 2) this.set("dropdownHidden", true);
  }

  /*
   * Set to show/hide when input is set to focus and blur.  This does the most basic
   * logic for showing and hiding the dropdown lists.
   */
  toggleSearchListings(e) {
    //show search listing area
    // e.preventDefault();
    switch (e.type) {
      case "focus":
        if (this.$.searchInput.value && this.$.searchInput.value.length > 0) {
          this.debouncedPredictiveSearch();
        } else {
          //Check for any recent searches stored in local storage
          let recent = SearchSessionStorageService.getRecentSearchData();
          if (recent.length > 0)
            this.set("recentSearchData", JSON.parse(recent));
        }
        this._displaySearchLists();
        break;
      case "blur":
        break;
    }
  }

  /*
   * Was going to try and use the same toggle value function for the keyboard as the mouse,
   * But ran into some issues, so left this specific to mouse in mouse out events.
   * This sets an active item for the hover effect, and also sets the search input value to
   * the title of the currently hovered over item.
   */
  toggleValue(e) {
    //on mouseover soft select item, set background input value to current soft selected item.
    let item = e.currentTarget;
    let activeItem = this._checkForActive(e.target.parentNode.children);
    if (e.type === "mouseover") {
      if (activeItem) {
        activeItem.item.classList.remove("active");
      }
      item.classList.add("active");
      this.$.searchInput.value = util.stripHTML(item.title);
    } else if (e.type === "mouseout") {
      item.classList.remove("active");
      this.$.searchInput.value = util.stripHTML(this.typedVal);
    }
  }

  /************************************/
  /***                              ***/
  /***      CLEAR/DELETE STUFF      ***/
  /***                              ***/
  /************************************/

  clearNsInput() {
    this.$.searchInput.value = "";
    this.psTotalItemsFound = 0;
    this.set("predictiveSearchData", []);
    if (this.typedVal != "") {
      this.set("typedVal", "");
    }
    if (this.$.submitButton) this.$.submitButton.focus();
    if (this.$.searchInput) this.$.searchInput.focus();

    // Reflect the input to a property to determine whether to show the clear icon
    this.searchInputValue = this.$.searchInput.value;
    // this._displaySearchLists();
  }

  clearRecentSearches() {
    SearchSessionStorageService.deleteRecentSearchData();
    this.recentSearchData = [];
    this._displaySearchLists();
  }

  /************************************/
  /***                              ***/
  /***   SEARCH RELATED FUNCTIONS   ***/
  /***                              ***/
  /************************************/

  seeMoreResults() {
    this.showMoreButton = false;
    this.predictiveSearch(this.psTotalItemsFound);
    this.showMoreClicked = true;
  }

  typeAhead() {
    if (this.searchAgeLocEnabled()) {
      let value = this._cleanUPSearchTerm(this.$.searchInput.value);
      if (value.length > 1) {
        let found = this.searchAssessments(value);
        if (!found) {
          this.predictiveSearch();
        }
      }
    } else {
      this.predictiveSearch();
    }
  }

  //Send null for values you don't need
  predictiveSearch(limit, fields, resultTypes, market, language, orderTypes) {
    if (!this.disablePredictiveSearch) {
      //Get Default values for parameters
      limit = limit
        ? limit
        : this.searchOptions && this.searchOptions.predictiveLimit
          ? this.searchOptions.predictiveLimit
          : 6;
      fields = fields
        ? fields
        : this.searchOptions && this.searchOptions.searchFields
          ? this.searchOptions.searchFields
          : null;
      resultTypes = resultTypes
        ? resultTypes
        : this.searchOptions && this.searchOptions.resultTypes
          ? this.searchOptions.resultTypes
          : null;
      market = market
        ? market
        : this.searchOptions && this.searchOptions.market
          ? this.searchOptions.market
          : this.market;
      language = language
        ? language
        : this.searchOptions && this.searchOptions.language
          ? this.searchOptions.language
          : this.language;
      orderTypes = orderTypes
        ? orderTypes
        : this.searchOptions &&
          this.searchOptions.orderTypes &&
          this.orderTypeInPredictive
          ? this.searchOptions.orderTypes
          : null;

      this.showMoreClicked = false;
      let value = this._cleanUPSearchTerm(this.$.searchInput.value);
      let _this = this;
      if (this.category === "Products" && value.length > 1) {
        ProductSearchService.quickSearch(
          value,
          fields,
          limit,
          market,
          language,
          resultTypes,
          orderTypes
        ).then(
          (response) => {
            if (this.showPricingInPredictive) {
              let skus = [];
              for (let i = 0; i < response.products.length; i++) {
                skus.push(response.products[i].sku);
              }
              this.pricesLoading = true;
              ProductStatusService.getProductStatus(
                skus,
                this.market.toUpperCase()
              )
                .then((productStatuses) => {
                  for (let p = 0; p < productStatuses.length; p++) {
                    for (let i = 0; i < response.products.length; i++) {
                      if (response.products[i].sku == productStatuses[p].SKU) {
                        response.products[i].setMarketAttributes(
                          productStatuses[p]
                        );
                        response.products[i].addPricingFromStatus(
                          productStatuses[p],
                          typeof user !== "undefined" && user
                            ? user.priceType
                            : "WRTL"
                        );
                        break;
                      }
                    }
                  }
                })
                .finally(function() {
                  let productArr = SearchBarAdapter.adaptLookAheadResults(
                    response.products,
                    _this.market,
                    _this.language,
                    typeof user !== "undefined" && user
                      ? user.priceType
                      : "WRTL"
                  );
                  // _this.dispatchEvent(new CustomEvent('on-ns-searchbar-predictive-search-result', {
                  //     detail: productArr
                  // }));
                  _this.psTotalItemsFound = response.totalNumFound;
                  _this.pricesLoading = false;
                  _this.set("predictiveSearchData", productArr);
                });
            }
            //Hide recent and popular searches from results bar if there are predictive search results
            if (response.products.length > 0) {
              _this.value = _this.typedVal;
              _this.$.recentSearches.hide();
              _this.$.popularSearches.hide();
              _this.$.popularSearches.style.setProperty("max-height", "0"); //Firefox bug fix
            }
            let productArr = SearchBarAdapter.adaptLookAheadResults(
              response.products,
              _this.market,
              _this.language,
              typeof user !== "undefined" && user ? user.priceType : "WRTL"
            );
            _this.dispatchEvent(
              new CustomEvent("on-ns-searchbar-predictive-search-result", {
                detail: productArr
              })
            );
            _this.psTotalItemsFound = response.totalNumFound;
            _this.set("predictiveSearchData", productArr);
          },
          (response) => {
            if (response === "timeout") {
              console.error("Solr timeout exceeded");
            } else {
              console.error("Exception in PredictiveSearch: ", response);
            }
          }
        );
      }
    }
  }

  submitSearch(item) {
    this.showSearchButtonTooltip = false;

    // this.blur();
    events.publish("openSpinner");
    if (!this.isSearchLoading) {
      this.isSearchLoading = true;
      let unCleanValue = util.stripHTML(this.$.searchInput.value);
      let value = this._cleanUPSearchTerm(this.$.searchInput.value);
      if (
        value !== "" &&
        (this.previousQuery !== value || this.mode === "cart")
      ) {
        this.previousQuery = value;
        let storageItem = { itemName: value };
        if (item && item.img) {
          storageItem.img = item.img;
        }
        this.typedVal = this.$.searchInput.value;
        this.psTotalItemsFound = 0;
        this.set("PredictiveSearchData", []);
        let productArr = [];
        if (this.category === "Products") {
          if (!this.searchRequestedHasFired) {
            events.publish(
              events.shop.SEARCH_REQUESTED,
              {
                searchType: "productSearch",
                typedQuery: this.typedVal,
                query: unCleanValue
              },
              { includeDataObject: false, publishToGTM: true }
            );
          }
          this.searchRequestedHasFired = false;
          let searchService = undefined;
          if (this.searchOptions) {
            let productFields,
              sortOrder,
              sortField,
              productResultTypes,
              orderTypes,
              market,
              language;
            if (this.searchOptions.searchFields)
              productFields = this.searchOptions.searchFields;
            if (this.searchOptions.sortOrder)
              sortOrder = this.searchOptions.sortOrder;
            if (this.searchOptions.sortField)
              sortField = this.searchOptions.sortField;
            if (this.searchOptions.resultTypes)
              productResultTypes = this.searchOptions.resultTypes;
            if (this.searchOptions.orderTypes)
              orderTypes = this.searchOptions.orderTypes;
            if (this.searchOptions.market) market = this.searchOptions.market;
            if (this.searchOptions.language)
              language = this.searchOptions.language;
            searchService = ProductSearchService.search(
              value,
              productFields,
              sortOrder,
              sortField,
              productResultTypes,
              orderTypes,
              market,
              language
            );
          } else {
            searchService = ProductSearchService.search(value);
          }
          searchService
            .then(
              (response) => {
                this.$.popularSearches.style.setProperty("max-height", "0"); //Firefox bug fix
                this.query = value;
                SearchSessionStorageService.setRecentSearchData(storageItem);
                if (typeof response !== "undefined") {
                  localStorage.removeItem("SEARCH_TERM_KEY");
                  this.set(
                    "searchResults",
                    SearchBarAdapter.adaptProductSearchResults(response)
                  );
                  let showSearchResults = true;
                  if (this.mode === "cart" || this.mode === "custom") {
                    this.clearNsInput();
                    showSearchResults = false;
                  }
                  events.publish(
                    events.shop.SEARCH_EXECUTED,
                    {
                      searchType: "fullSearch",
                      typedQuery: this.typedVal,
                      query: unCleanValue,
                      resultsObject: this.searchResults,
                      showSearchResults: showSearchResults
                    },
                    { includeDataObject: false, publishToGTM: true }
                  );
                }
                if (typeof response === "undefined") {
                  this.set("searchResults", []);
                }
                this.isSearchLoading = false;
                let recent = SearchSessionStorageService.getRecentSearchData();
                if (recent.length > 0)
                  this.set("recentSearchData", JSON.parse(recent));
                events.publish("closeSpinner");
              },
              (response) => {
                //Failed response
                if (response === "timeout") {
                  console.error("Solr timeout exceeded");
                } else {
                  console.error(
                    "Exception in Product Search Service: ",
                    response
                  );
                }
                events.publish("closeSpinner");
                events.publish(
                  events.shop.SEARCH_EXECUTED,
                  {
                    searchType: "fullSearch",
                    typedQuery: this.typedVal,
                    query: unCleanValue,
                    resultsObject: ["reset", Math.random()],
                    showSearchResults:
                      this.mode == "cart" || this.mode == "custom"
                        ? false
                        : true
                  },
                  { includeDataObject: false, publishToGTM: true }
                );
                this.isSearchLoading = false;
              }
            )
            .catch((err) => {
              console.log("err: ", err);
              events.publish("closeSpinner");
              events.publish(
                events.shop.SEARCH_EXECUTED,
                {
                  searchType: "fullSearch",
                  typedQuery: this.typedVal,
                  query: unCleanValue,
                  resultsObject: ["reset", Math.random()],
                  showSearchResults:
                    this.mode == "cart" || this.mode == "custom" ? false : true
                },
                { includeDataObject: false, publishToGTM: true }
              );
              this.isSearchLoading = false;
            });
        }
        if (this.$.submitButton) this.$.submitButton.focus();
        if (this.$.searchInput) this.$.searchInput.blur();
      } else {
        this.isSearchLoading = false;
        events.publish("closeSpinner");
      }
    }
  }

  _updateSearchValue() {
    this.$.searchInput.value = this.value;
  }

  _cleanUPSearchTerm(searchTerm) {
    searchTerm = searchTerm.trim();
    searchTerm = searchTerm.replace(/®/g, "");
    searchTerm = searchTerm.replace(/©/g, "");
    return searchTerm.toLowerCase();
  }

  showAddToCart(item) {
    return (
      this.hasSKU(item) &&
      this.notBaseSKU(item) &&
      this.mode !== "cart" &&
      !this.hideAddToBag
    );
  }

  showSearchButton() {
    return !this.noSearchButton && this.mode !== "cart";
  }

  notBaseSKU(item) {
    return item.sku.substring(2, 4) !== "55";
  }

  hasSKU(item) {
    return typeof item.sku !== "undefined";
  }

  formatPrice(price) {
    return CurrencyService.format(price, this.market, this.language);
  }

  formatPV(pv) {
    if (typeof pv === "number") return "&bull; " + this.PSVString + ":" + pv;
    else return "";
  }

  hasUser() {
    return typeof user !== "undefined" && user && user.id;
  }

  displaySku(item) {
    return item.agelocme ? item.agelocme.code : item.sku;
  }

  agelocData(item) {
    return item.agelocme ? JSON.stringify(item.agelocme) : "";
  }

  addToCart(e) {
    e.stopPropagation();
    let item = {
      sku: e.currentTarget.parentElement.sku,
      itemName: e.currentTarget.parentElement.title,
      img: e.currentTarget.parentElement.def,
      fullImage: e.currentTarget.parentElement.def,
      title: e.currentTarget.parentElement.title,
      isExclusive: e.currentTarget.parentElement.isExclusive
    };
    if (
      e.currentTarget.parentElement.ageloc &&
      e.currentTarget.parentElement.ageloc != ""
    ) {
      item.agelocme = new Agelocme(JSON.parse(e.currentTarget.ageloc));
    }
    //Solr converts boolean into String value of true
    if (item.isExclusive === "true" || item.isExclusive === true) {
      CartService.getAddToCartQty(item.sku)
        .then((itemQuantity) => {
          if (itemQuantity > 0) {
            this.addItemToCart(item);
          } else {
            this.doPDPRedirect(item);
          }
        })
        .catch((error) => {
          console.error("Failed to retrieve cart service", error);
          this.doPDPRedirect(item);
        });
    } else {
      if (
        e.currentTarget.parentElement.ageloc &&
        e.currentTarget.parentElement.ageloc != ""
      ) {
        item.agelocme = new Agelocme(JSON.parse(e.currentTarget.ageloc));
      }
      this.addItemToCart(item);
    }
  }

  addItemToCart(item) {
    let userID = null;
    if (typeof user !== "undefined" && user && user.id) {
      userID = user.id;
    }
    let options = {
      sku: item.sku,
      cntryCd: this.market.toUpperCase(),
      language: this.language,
      qty: 1,
      userId: userID,
      isAtpCheck: false,
      referrer: "search"
    };
    if (item.agelocme && item.agelocme != "") {
      options.agelocme = item.agelocme;
    }
    //events.publish(events.shop.SEARCH_ADD_TO_CART, {sku: options.sku});
    CartService.addSkuToCart(options).then(() => {
      //events.publish(events.shop.ADD_TO_CART);
      events.publish(events.shop.SHOW_ADD_TO_BAG);
    });
  }

  pushSearchItem(e) {
    let item = {};
    item.itemName = e.currentTarget.title;
    item.sku = e.currentTarget.sku;
    if (e.currentTarget.def) {
      item.img = e.currentTarget.def;
      item.fullImage = item.img;
      if (e.currentTarget.ageloc && e.currentTarget.ageloc != "") {
        item.agelocme = new Agelocme(JSON.parse(e.currentTarget.ageloc));
      }
    }
    item.title = item.itemName;
    item.isExclusive = e.currentTarget.isExclusive;
    if (item.itemName) {
      if (e.currentTarget.parentElement.id == "predictiveSearchItems") {
        events.publish(
          events.shop.SEARCH_REQUESTED,
          {
            searchType: "predictiveSearch",
            typedQuery: this.typedVal,
            query: item.itemName,
            item: item
          },
          { includeDataObject: false, publishToGTM: true }
        );
        events.publish(events.shop.SEARCH_TYPEAHEAD, {
          typedQuery: this.typedVal,
          query: item.itemName,
          item: item
        });
      } else if (e.currentTarget.parentElement.id == "popularSearchItems") {
        events.publish(
          events.shop.SEARCH_REQUESTED,
          {
            searchType: "popularProductsSearch",
            typedQuery: this.typedVal,
            query: item.itemName,
            item: item
          },
          { includeDataObject: false, publishToGTM: true }
        );
        events.publish(events.shop.SEARCH_POPULAR_PRODUCTS, { item: item }); //Included for analytics
      } else if (e.currentTarget.parentElement.id == "recentSearchItems") {
        events.publish(
          events.shop.SEARCH_REQUESTED,
          {
            searchType: "recentSearch",
            typedQuery: this.typedVal,
            query: item.itemName,
            item: item
          },
          { includeDataObject: false, publishToGTM: true }
        );
        events.publish(events.shop.SEARCH_RECENT, { item: item });
        this.searchRequestedHasFired = true;
      }

      //If you are clicking on an item in predictive search (and not in cart mode), go to the UPDP for that SKU
      //Otherwise, do a search for the text
      if (this.redirectToPDP(e, item)) {
        this.doPDPRedirect(item);
      } else if (this.addToCartOnClick) {
        this.addItemToCart(item);
      } else if (
        this.mode != "custom" &&
        this.mode != "cart" &&
        !item.agelocme
      ) {
        item.img = e.currentTarget.def;
        let itemName = util.stripHTML(item.itemName);
        this.$.searchInput.value = itemName;
        this.set("typedVal", itemName);

        this.blur();
        this.submitSearch(item);
      }
    }
  }

  /**
   * Will redirect to the PDP
   * @param {*} item
   */
  doPDPRedirect(item) {
    SitesSessionStorageService.writeItem(KEY_BREADCRUMB_BACK, true);
    SearchSessionStorageService.setRecentSearchData(item);
    if (this.market.toLowerCase() === "jp")
      this.href =
        "/content/markets/" +
        this.language +
        "_" +
        this.market +
        "/products/product." +
        item.sku +
        (this.context ? "." + this.context : "") +
        ".html";
    else
      this.href =
        "/content/nuskin/" +
        this.language +
        "_" +
        this.market +
        "/products/product." +
        item.sku +
        (this.context ? "." + this.context : "") +
        ".html";
    window.location = this.href;
  }

  redirectToPDP(e, item) {
    return (
      item.sku &&
      item.sku.length == 8 &&
      this.mode !== "cart" &&
      this.mode !== "custom" &&
      !item.agelocme
    );
  }

  /************************************/
  /***                              ***/
  /***    KEYBOARD EVENT HANDLERS   ***/
  /***                              ***/
  /************************************/

  _checkForActive(items) {
    for (let i = 0; i < items.length; i++) {
      if (items[i].classList.contains("active")) {
        return { item: items[i], index: i };
      }
    }
    return false;
  }

  analyzeKey(e) {
    /*
     * Monster function built to analyze what key has been pressed and the corresponding
     * logic for the said action.
     */
    //We first establish width of device and the key that was pressed.
    let width = document.body.clientWidth;
    let key = e.keyCode;
    let list;
    /*
     * The below block sets the context for the dropdown list and allows us to know what we are
     * to loop through on up or down arrow press.
     */
    if (
      this.predictiveSearchData &&
      this.predictiveSearchData.length > 0 &&
      width > 1023
    ) {
      //if predictive searches are present, they take the focus.
      list = this.$.searchListings.querySelectorAll(
        'iron-collapse:not([id="recentSearches"]) li.listItem'
      );
    } else if (width > 1023) {
      //if there aren't predictive searches, then on screens larger then 1023px we need to loop through ALL lists
      //available.  Example: When there are both recent searches AND popular searches
      list = this.$.searchListings.querySelectorAll("li.listItem");
    } else if (
      width < 1024 &&
      !!this.predictiveSearchData && this.predictiveSearchData.length > 0
    ) {
      // On mobile we don't want to include popularSearches once we have done a predictive search
      list = this.$.predictiveSearches.querySelectorAll("li.listItem");
    } else if (
      width < 1024 &&
      !!this.recentSearchData && this.recentSearchData.length > 0
    ) {
      //If on mobile (mobile at this point for this element being defined as anything 1023px and below) We only show
      //one list at a time and recent searches take the cake over popular searches.
      list = this.$.recentSearches.querySelectorAll("li.listItem");
    } else {
      list = this.$.popularSearches.querySelectorAll("li.listItem");
    }
    let listLength = list.length;
    let arrComp = listLength - 1;
    let activeItem;
    /*
     *  Case Statement to manage what needs to be done depending on which key is pressed.
     */
    switch (key) {
      case 8: { //Back Space
        this.typedVal = this.$.searchInput.value;
        if (this.$.searchInput.value.length === 0) {
          this.psTotalItemsFound = 0;
          this.set("predictiveSearchData", []);
        } else {
          this.debouncedPredictiveSearch();
        }
        break;
      }
      case 13: { //Enter Key
        if (!this.disableSearchOnEnter) {
          this.showSearchButtonTooltip = false;
          this.blur();
          this.submitSearch();
        }
        break;
      }
      case 27: { //Esc Key
        this.clearNsInput();
        break;
      }
      case 38: { //Up Arrow
        //Find out if an item is already active
        activeItem = this._checkForActive(list);
        let prevItem = activeItem.index - 1;
        if (activeItem) {
          if (activeItem.index === 0) {
            list[arrComp].classList.add("active");
            this.$.searchInput.value = util.stripHTML(list[arrComp].title);
          } else {
            list[prevItem].classList.add("active");
            this.$.searchInput.value = util.stripHTML(list[prevItem].title);
          }
          activeItem.item.classList.remove("active");
        } else if (!activeItem) {
          list[arrComp].classList.add("active");
          this.$.searchInput.value = util.stripHTML(list[arrComp].title);
        }
        break;
      }
      case 40: { //Down Arrow
        //control selection
        activeItem = this._checkForActive(list);
        let nextItem = activeItem.index + 1;
        if (activeItem) {
          if (activeItem.index === arrComp) {
            list[0].classList.add("active");
            this.$.searchInput.value = util.stripHTML(list[0].title);
          } else {
            list[nextItem].classList.add("active");
            this.$.searchInput.value = util.stripHTML(list[nextItem].title);
          }
          activeItem.item.classList.remove("active");
        } else if (!activeItem) {
          list[0].classList.add("active");
          this.$.searchInput.value = util.stripHTML(list[0].title);
        }
        break;
      }
      default: {
        this.typedVal = this.$.searchInput.value;
        this.debouncedPredictiveSearch();
        break;
      }
    }
  }

  /************************************/
  /***                              ***/
  /***      ON ERROR FUNCTIONS      ***/
  /***                              ***/
  /************************************/

  imgError(e) {
    e.target.classList.add("show-logo");
  }

  imgLoad(e) {
    e.target.classList.remove("show-logo");
  }

  /************************************/
  /***                              ***/
  /***      MISC FUNCTIONS          ***/
  /***                              ***/
  /************************************/

  getCartMode() {
    if (this.mode === "cart") {
      return "cart-mode";
    }
  }

  focusInput() {
    this.focused = true;
    setTimeout(() => {
      this.$.searchInput.focus();
    }, 10);
  }

  focus() {
    this.focused = true;
    this.toggleSearchListings({ type: "focus" });
  }

  blur() {
    this.focused = false;
    this.toggleSearchListings({ type: "blur" });
  }

  _preventDefault(e) {
    e.preventDefault();
  }

  _handleBlur() {
    setTimeout(() => {
      if (!this._ancestor(document.activeElement, this)) {
        this.blur();
      }
    }, 200);
  }

  /**
   * Search the ancestors of a given node and see if they match the match.
   * @param {DOM node} node
   * @param {DOM node} match
   */
  _ancestor(node, match) {
    if (!node) return null;
    do {
      if (!match || match == node) break;
    } while (node === node.parentNode);

    return node;
  }

  _searchButtonActivator(value) {
    if (!this.value) {
      this.value = value;
    }
    this.submitButtonActive = value.length >= 3;

    if (this.submitButtonActive) {
      if (this.usingTooltips && this.initialShowSearchButtonTooltip) {
        this.showSearchButtonTooltip = true;
        this.initialShowSearchButtonTooltip = false;
        let buttonsKey = SitesLocalStorageService.getItem(
          SEARCH_BUTTON_TOOLTIPS_KEY
        );
        let buttonTooltip = buttonsKey.showSearchButtonTooltip;
        let buttonToolMod = buttonsKey.searchButtonMod || false;
        if (typeof buttonTooltip !== "number") buttonTooltip = 0;
        if (buttonTooltip % 2 == 0) {
          if (!buttonToolMod) {
            buttonTooltip /= 2;
            buttonToolMod = true;
          }
        }
        SitesLocalStorageService.writeItem(SEARCH_BUTTON_TOOLTIPS_KEY, {
          showSearchButtonTooltip: ++buttonTooltip,
          searchButtonMod: buttonToolMod
        });
        setTimeout(() => {
          this.showSearchButtonTooltip = false;
        }, 4000);
      }
    }
  }

  disableSearchTooltip(e) {
    e.stopPropagation();
    this.showSearchButtonTooltip = false;
    SitesLocalStorageService.writeItem(SEARCH_BUTTON_TOOLTIPS_KEY, {
      showSearchButtonTooltip: 100
    });
  }

  disableIconsContainerTooltip() {
    this.showIconsContainerTooltip = false;
    SitesLocalStorageService.writeItem(ICONS_CONTAINER_TOOLTIPS_KEY, {
      showIconsContainerTooltip: 100
    });
  }

  /************************************/
  /***                              ***/
  /***      AGELOC ME FUCTIONS      ***/
  /***                              ***/
  /************************************/

  searchAgeLocEnabled() {
    return (
      this.nsConfig.enableAssessmentSearch &&
      this.hasUser() &&
      this.searchAgeloc
    );
  }

  async loadUserAssessments() {
    let _this = this;
    let runConfig = RunConfigService.getRunConfig();
    const localeCode = `${runConfig.language || "en"}_${runConfig.country || "US"}`;

    const siteUrl = window.location.origin.startsWith("http://localhost")
      ? runConfig.baseUrl || "https://test.nuskin.com"
      : window.location.origin;

    const serviceData = await MarketHeaderService.getMarketHeaderData(
      `/content/nuskin/${localeCode}/home.html`,
      siteUrl,
      false,
      "searchbar"
    );

    const searchAgeLocUseV2 = !!serviceData.searchAgeLocUseV2;

    let _getAssessments = AssessmentService.getAssessments;
    if (searchAgeLocUseV2) {
      _getAssessments = AssessmentService.getAssessmentsV2;
    }

    _getAssessments(
      function success(data) {
        if (data.assessments) {
          _this.assessments = data.assessments;
        }
        _this.getAgelocProduct(false);
        _this.getAgelocProduct(true);
      },
      function failed(data) {}
    );
  }

  getAgelocProduct(isCoreSolution) {
    let _this = this;
    let sku = isCoreSolution
        ? this.nsConfig.agelocme.coreSku
        : this.nsConfig.agelocme.sku,
      options;

    if (sku) {
      options = {
        sku: sku,
        cntryCd: this.country,
        language: this.language,
        qty: 1,
        isAdr: false // add as order item by default. If item is adr only it will be set that way
      };

      ProductService.getProductBySku(options).then((response) => {
        if (response.success) {
          if (isCoreSolution) {
            _this.agelocMeCoreProduct = response.product;
          } else {
            _this.agelocMeProduct = response.product;
          }
        }
      });
    }
  }

  searchAssessments(part) {
    let found = false,
      matches = [];
    if (this.assessments && this.assessments.length > 0) {
      let regExp = new RegExp(part, "i");
      this.assessments.map(function(assessment) {
        if (
          regExp.test(assessment.productCode || assessment.code) ||
          regExp.test(assessment.profileName)
        ) {
          matches.push(assessment);
        }
      });

      if (matches && matches.length > 0) {
        if (this.agelocMeProduct) {
          let _this = this;
          let matchProducts = [];
          matches.map(function(match) {
            let matchProduct = new Product(
              match.isCoreSolution
                ? _this.agelocMeCoreProduct
                : _this.agelocMeProduct
            );

            if (match.isCoreSolution) {
              if (_this.agelocMeCoreProduct) {
                matchProduct = new Product(_this.agelocMeCoreProduct);
              }
            } else {
              if (_this.agelocMeProduct) {
                matchProduct = new Product(_this.agelocMeProduct);
              }
            }
            if (matchProduct) {
              matchProduct.agelocme = new Agelocme({
                code: match.productCode || match.code,
                isCoreSolution: match.isCoreSolution,
                label: match.profileName || `${match.label} - ${match.code}`,
                name: match.name
              });
              matchProducts.push(matchProduct);
            }
            return match;
          });
          //Hide recent and popular searches from results bar if there are predictive search results
          if (matchProducts.length > 0) {
            this.value = this.typedVal;
            this.$.recentSearches.hide();
            this.$.popularSearches.hide();
            this.$.popularSearches.style.setProperty("max-height", "0"); //Firefox bug fix
          }
          let productArr = SearchBarAdapter.adaptLookAheadResults(
            matchProducts,
            this.market,
            this.language,
            typeof user !== "undefined" && user ? user.priceType : "WRTL"
          );
          this.dispatchEvent(
            new CustomEvent("on-ns-searchbar-predictive-search-result", {
              detail: productArr
            })
          );
          this.psTotalItemsFound = matchProducts.length;
          this.set("predictiveSearchData", productArr);
          found = true;
        }
      }
    }
    return found;
  }

  isExclusiveOffer(item) {
    return item.isExclusive === "true" || item.isExclusive === true;
  }
}

customElements.define(NsSearchbarLegacy.is, NsSearchbarLegacy);
